import React from 'react'
import ProjectLayout from '../../../../../layout/components/ProjectLayout'
import ProjectNotes from '../components/ProjectNotes'
import { useParams } from 'react-router-dom'
import ActivityTimeline from '../components/activity/ActivityTimeline';


function ProjectActivityPage() {
    const {id} = useParams();
    return (
        <ProjectLayout>
            <div className='row'>
                <div className='col-md-9'>
                    <ActivityTimeline projectId={id} autoload={true} />
                </div>
                <div className='col-md-3'>
                    <ProjectNotes projectId={id} autoload={true} />
                </div>
            </div>
        </ProjectLayout>
    )
}

export default ProjectActivityPage